import React, { useEffect, useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import { CiFilter } from "react-icons/ci";
import { MdOutlineSort } from "react-icons/md";
import { IoMdTime } from "react-icons/io";
import Pic1 from "../../../assets/images/Eductional/Pic1.png";
import Pic2 from "../../../assets/images/Eductional/Pic2.png";
import Pic3 from "../../../assets/images/Eductional/Pic3.png";
import { Router, useNavigate } from "react-router-dom";
import {
  getCategories,
  getresources,
  getSpecialitiesList,
} from "../../../services/services";
import Spinner from "../../../components/Loader/Spinner";

const Resources = () => {
  const [activeTab, setActiveTab] = useState("all");
  const [filters, setFilters] = useState({
    specialist: [],
    contentType: [],
    categories: [],
  });
  const [categories, setCategories] = useState([]);
  const [Specialist, setSpecialist] = useState([]);
  const [resources, setResources] = useState([]);
  const [loadingResources, setLoadingResources] = useState(false);
  const [sort, setSort] = useState("");

  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  console.log("sort", sort);

  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [isSortOpen, setIsSortOpen] = useState(false);

  const navigate = useNavigate();
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await getCategories();

        const data = res?.data || res;

        const formatted = data.map((item) => ({
          label: item.name,
          value: item._id,
        }));

        setCategories(formatted);
      } catch (err) {
        console.log("Category fetch error", err);
      }
    };

    const fetchSpecialists = async () => {
      try {
        const res = await getSpecialitiesList();

        const list = res?.speciality || [];

        const formatted = list.map((item) => ({
          label: item.specialityName,
          value: item._id,
        }));

        setSpecialist(formatted);
      } catch (err) {
        console.log("Specialist fetch error", err);
      }
    };

    fetchCategories();
    fetchSpecialists();
  }, []);

  const fetchResources = async (pageNumber = 1) => {
    try {
      setLoadingResources(true);

      const category =
        activeTab === "all" ? filters.categories.join(",") : activeTab;

      const speciality = filters.specialist.join(",");

      const typeMap = {
        Articles: "article",
        Videos: "video",
        PDF: "pdf",
      };

      const type = filters.contentType.includes("All")
        ? ""
        : filters.contentType.map((t) => typeMap[t]).join(",");

      const res = await getresources(
        category,
        speciality,
        type,
        pageNumber,
        sort,
      );

      const list = res?.data?.data || [];
      const total = res?.data?.totalCount || 0;

      setTotalCount(total);

      setResources((prev) => (pageNumber === 1 ? list : [...prev, ...list]));
    } catch (err) {
      console.log("Resources fetch error", err);
    } finally {
      setLoadingResources(false);
    }
  };

  useEffect(() => {
    setPage(1);
    fetchResources(1);
  }, [activeTab, filters, sort]);

  const contentTypeOptions = ["All", "Articles", "Videos", "PDF"];

  const sortOptions = [
    { label: "A-Z", value: "A-Z" },
    { label: "Z-A", value: "Z-A" },
    { label: "Newest First", value: "Newest First" },
    { label: "Oldest First", value: "Oldest First" },
  ];

  const [visibleCount, setVisibleCount] = useState(6);

  const handleLoadMore = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchResources(nextPage);
  };

  const handleCheckboxChange = (type, value) => {
    setFilters((prev) => {
      const alreadySelected = prev[type].includes(value);

      return {
        ...prev,
        [type]: alreadySelected
          ? prev[type].filter((item) => item !== value)
          : [...prev[type], value],
      };
    });
  };

  useEffect(() => {
    const handleClickOutside = () => {
      setIsFilterOpen(false);
      setIsSortOpen(false);
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const tabs = [
    { key: "all", label: "All" },
    ...categories.map((cat) => ({
      key: cat.value,
      label: cat.label,
    })),
  ];

  let finalData = resources;

  if (filters.categories.length > 0) {
    finalData = finalData.filter((item) =>
      filters.categories.some((catId) =>
        item.categoriesData?.some((c) => c._id === catId),
      ),
    );
  }
  return (
    <div
      className="mt-4 px-4 py-6"
      style={{
        marginLeft: "auto",
        marginRight: "auto",
        maxWidth: "1200px",
      }}
    >
      <div className="flex flex-col gap-2">
        <h1 className="text-xl">Resources</h1>
        <p>
          Elevating human performance through scientific dietary wisdom. Explore
          our
          <br /> essential guides to metabolic health, superfoods, and the
          science of nourishment.
        </p>
      </div>
      {/* <div
        className="flex justify-between mt-6 mb-9 "
        style={{ flexWrap: "wrap", gap: "10px" }}
      > */}
      <div className="flex items-end  justify-between mt-12 mb-9 gap-4">
        <div className="flex-1 min-w-0 overflow-x-auto">
          <div className="flex whitespace-nowrap border-b space-x-5 border-Lightgray items-end">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                className={`relative pb-3 px-3  transition-all duration-200 ${
                  activeTab === tab.key
                    ? "text-primary font-semibold"
                    : "text-Textgray"
                }`}
              >
                {tab.label}

                <span
                  style={{
                    position: "absolute",
                    left: 0,
                    bottom: 0,
                    height: "2px",
                    width: activeTab === tab.key ? "100%" : "0",
                    backgroundColor:
                      activeTab === tab.key ? "#9A72C9" : "transparent",
                    transition: "all 0.3s ease",
                  }}
                />
              </button>
            ))}
          </div>
        </div>
        {/* Tabs Wrapper */}

        {/* Global Filter + Sort */}
        <div className="flex flex-shrink-0 items-end gap-2 mb-3">
          {/* FILTER BUTTON */}
          <div className="relative">
            <button
              onClick={(e) => {
                e.stopPropagation();
                setIsFilterOpen(!isFilterOpen);
                setIsSortOpen(false);
              }}
              className="flex items-center gap-2 border px-4 py-2 rounded-full text-md text-primary bg-white shadow-sm border-primary"
            >
              <CiFilter size={18} className="" />
              Filter
            </button>

            {isFilterOpen && (
              <div
                className="absolute bg-white border rounded-xl shadow-lg z-10 p-4 space-y-4"
                style={{
                  marginTop: "8px", // mt-2
                  width: "256px", // w-64
                  maxHeight: "300px", // max-h-[300px]
                  overflowY: "auto", // overflow-y-auto
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <div>
                  <h4 className="font-semibold mb-2 ">Specialist</h4>
                  {Specialist.length === 0 ? (
                    <p className="text-sm text-gray-400">Loading...</p>
                  ) : (
                    Specialist.map((item) => (
                      <label
                        key={item.value}
                        className="flex items-center gap-2 mb-1"
                      >
                        <input
                          type="checkbox"
                          checked={filters.specialist.includes(item.value)}
                          onChange={() =>
                            handleCheckboxChange("specialist", item.value)
                          }
                          className="cursor-pointer"
                        />
                        {item.label}
                      </label>
                    ))
                  )}
                </div>

                {/* Content Type */}
                <div>
                  <h4 className="font-semibold mb-2 ">Content Type</h4>
                  {contentTypeOptions.map((item) => (
                    <label key={item} className="flex items-center gap-2 mb-1">
                      <input
                        type="checkbox"
                        checked={filters.contentType.includes(item)}
                        onChange={() =>
                          handleCheckboxChange("contentType", item)
                        }
                        className="cursor-pointer"
                      />
                      {item}
                    </label>
                  ))}
                </div>

                {/* Categories */}
                {/* <div>
                  <h4 className="font-semibold mb-2 ">Categories</h4>
                  {categories.map((item) => (
                    <label
                      key={item.value}
                      className="flex items-center gap-2 mb-1 "
                    >
                      <input
                        type="checkbox"
                        checked={filters.categories.includes(item.value)}
                        onChange={() =>
                          handleCheckboxChange("categories", item.value)
                        }
                        className="cursor-pointer"
                      />
                      {item.label}
                    </label>
                  ))}
                </div> */}
              </div>
            )}
          </div>

          {/* SORT BUTTON */}
          <div className="relative">
            <button
              onClick={(e) => {
                e.stopPropagation();
                setIsSortOpen(!isSortOpen);
                setIsFilterOpen(false);
              }}
              className="flex items-center gap-2 border-l border-r border-b border-primary border-t-0 px-4 py-2 rounded-full text-white shadow-sm"
              style={{
                background:
                  "linear-gradient(to bottom, #9A72C9 0%, #9A72C9 30%, #F4C4EE 100%)",
              }}
            >
              <MdOutlineSort size={18} />
              Sort
            </button>

            {isSortOpen && (
              <div className="absolute mt-2 w-40 bg-white border rounded-lg shadow-md z-10">
                {sortOptions.map((item) => (
                  <div
                    key={item.value}
                    onClick={() => {
                      setSort(item.value);
                      setIsSortOpen(false);
                    }}
                    className="px-4 py-2 hover:bg-gray cursor-pointer"
                  >
                    {item.label}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      <div
        style={{
          minHeight: "60vh",
          maxHeight: "75vh",
          overflowY: "auto",
          paddingRight: "8px",
        }}
      >
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-7">
          {finalData.map((item) => (
            <div
              key={item.id}
              className="cursor-pointer"
              onClick={() =>
                navigate(`/resources/detail/${item._id}`, {
                  state: item,
                })
              }
            >
              <div className="relative rounded-2xl overflow-hidden">
                <img
                  src={item.cover_image?.imageUrl || Pic1}
                  alt=""
                  className="w-full h-96 object-cover"
                />
                {item.categoriesData.length > 0 && (
                  <span className="absolute top-3 left-3 text-xs bg-Light-gray font-semibold px-3 py-1 rounded-full shadow">
                    {item.categoriesData?.map((c) => c.name).join(", ")}
                  </span>
                )}
              </div>

              <div className="py-4">
                <h3 className="text-lg">{item.title}</h3>
                <p
                  style={{
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                  }}
                  className="text-sm text-gray-500 mt-2"
                >
                  {item.desc}
                </p>

                <p className="text-sm text-gray-500 mt-2 line-clamp-2">
                  {item.categoriesData?.map((c) => c.name).join(", ")}
                </p>

                <div className="flex justify-between uppercase text-sm font-bold text-gray-400 mt-8">
                  <span>
                    {item?.createdAt
                      ? new Date(item.createdAt).toLocaleDateString("en-US", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })
                      : ""}
                  </span>

                  {/* <span className="flex items-center gap-1">
                    <IoMdTime className="font-bold" />
                    {item.read}
                  </span> */}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* LOAD MORE BUTTON */}
        {resources.length < totalCount && !loadingResources && (
          <div className="flex justify-center mt-6">
            <button
              onClick={handleLoadMore}
              disabled={loadingResources}
              style={{
                background:
                  "linear-gradient(to bottom, #9A72C9 0%, #9A72C9 30%, #F4C4EE 100%)",
              }}
              className="px-8 py-3 rounded-full border border-primary text-white transition"
            >
              {loadingResources ? "Loading..." : "Load More Articles"}
            </button>
          </div>
        )}

        {loadingResources ? (
          <Spinner />
        ) : finalData.length === 0 ? (
          <p className="md:col-span-3 lg:col-span-5 col-span-2 text-center text-md font-semibold text-danger">
            No data found
          </p>
        ) : null}
      </div>
    </div>
  );
};

export default Resources;
